import { Api } from './Api';

export default {
    /*  1. Get all data by Criteria*/
    GetModuleByCriteria(body = { keyword: '' }) {
        return Api().post('/Module/GetModuleByCriteria', body);
    },

    /*  1. Get all data by keyword */
    getModules(keyword = '') {
        var body = { keyword: keyword }
        return Api().post('/Module/GetModuleByCriteria', body);
    },

    /*  1. Get all data */
    //getModules(keyword = '') {
    //    return Api().get(`/Module${keyword ? '?Keyword=' + keyword : ''}`);
    //},

    /*  2. Get one column */
    getModule(id) {
        return Api().get(`/Module/${id}`);
    },

    /*  3. Create one column */
    saveModule(body) {
        return Api().post(`/Module`, body);
    },

    /*  4. Delete one or more columns */
    deleteModules(modules) {
        return Api().post(`/Module/DeleteModule`, modules);
    },

    /*  5. post one or more columns */
    postModules(modules) {
        return Api().post(`/Module/PostModule`, modules);
    },
}